<template>
  <div>
    <base-header class="pb-5">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block" v-if="$route.meta.breadcrumbTitle">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col lg="6" cols="5" class="text-right">
          <base-button size="sm" type="neutral" @click="showFilters=!showFilters">Filters</base-button>
        </b-col>
      </b-row>
      <b-row v-if="showFilters">
        <b-col cols="2">
          <div class="form-group">
            <label class="form-control-label" for="fromDate">From date</label>
            <base-input type="date" v-model="filters.fromDate" id="fromDate"></base-input>
          </div>
        </b-col>
        <b-col cols="2">
          <div class="form-group">
            <label class="form-control-label" for="toDate">To date</label>
            <base-input type="date" v-model="filters.toDate" id="toDate"></base-input>
          </div>
        </b-col>
        <b-col cols="2">
          <label class="form-control-label" for="motorbike">Motorbike</label>
            <div class="form-group">
              <select class="form-control" v-model="filters.motorbike">
                <option v-bind:value="null">Any</option>
                <option v-for="motorbike in motorbikes" v-bind:key="motorbike.id" v-bind:value="motorbike.id">{{motorbike._name}}</option>
              </select>
            </div>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--5">
      <div class="card mb-4">
        <toosho-map
          ref="map"
          keep-ids-to-show
          :from-date="computedFilters.fromDate"
          :to-date="computedFilters.toDate"
          :motorbike="computedFilters.motorbike"
          @shownTracksChanged="(tracks) => shownTracks = tracks"
          @allTracksChanged="(tracks) => allTracks = tracks">
          <!-- <template v-slot:buttons-left>
            <b-nav-item-dropdown text="Assign visibles to" :disabled="!allTracks.length || !shownTracks.length">  
              <b-dropdown-item @click="assignVisiblesTo(null)">- No motorbike -</b-dropdown-item>
              <b-dropdown-item
                @click="assignVisiblesTo(motorbike)"
                v-for="motorbike in motorbikes"
                v-bind:key="motorbike._id">
                  {{motorbike._name}}
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </template> -->
        </toosho-map>
      </div>
    </b-container>
  </div>
</template>
<script>
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
  import TooshoMap from '../../components/TooshoMap.vue'
  import { mapActions, mapGetters } from 'vuex';


  export default {
    name: 'map-page',
    components: {
      RouteBreadCrumb,
      TooshoMap
    },
    data() {
      return {
        showFilters: false,
        filters: {
          fromDate: new Date(new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 15).setUTCHours(0, 0, 0, 0)).toInputDateFormat(),
          toDate: new Date(new Date().setUTCHours(23, 59, 59, 999)).toInputDateFormat(),
          motorbike: null
        },
        allTracks: [],
        shownTracks: []
      }
    },
    computed: {
      ...mapGetters({
        motorbikes: 'motorbikes/motorbikes'
      }),
      computedFilters() {
        return {
          fromDate: this.filters.fromDate.fromInputDateFormatToDate(),
          toDate: this.filters.toDate.fromInputDateFormatToDate(),
          motorbike: this.filters.motorbike
        }
      }
    },
    async mounted() {
      await this.fetchMotorbikes()
    },
    methods: {
      ...mapActions({
        fetchMotorbikes: 'motorbikes/fetch',
        editTrack: 'tracks/edit'
      }),
      assignVisiblesTo(motorbike) {
        this.shownTracks.forEach(trackId => {
          this.editTrack({id: trackId, data: { motorbike }})
        })
      }
    }
  };
</script>
